import React from 'react';

const PortoAeroportoContext = React.createContext();

export default PortoAeroportoContext;
